// React libs
import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
// Services
import MapService from '../Services/MapService';
// Types
import * as CoreTypes from '../../../../Core/Data/Models/Core.type';
import * as MapTypes from '../Models/Map.type';
// Common
import CoreCommon from '../../../../Core/Resources/Common';

export interface IGetPoiLinksHook extends CoreTypes.IHook<MapTypes.IPoiLink[] | undefined> { }

const usePoiLinks = (): IGetPoiLinksHook => {
  // Variables
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(['common']);

  // State
  const [data, setData] = useState<MapTypes.IPoiLink[] | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Effects
  useEffect(() => {
    setIsLoading(true)
    MapService.getPoiLinks()
      .then((data: MapTypes.IData<MapTypes.IPoiLink>) => {
        setData(data.data)
        setIsLoading(false)
      })
      .catch((e: CoreTypes.IWsException) => {
        enqueueSnackbar(
          e?.error?.message || t('common:errors.defaultMessage'),
          {
            ...CoreCommon.Constantes.snackbarDefaultProps,
            variant: 'error',
          }
        );
        setIsLoading(false);
      });
  }, [enqueueSnackbar, t])

  return { data, isLoading }
}

export default usePoiLinks
